import Loader from "components/shared/loader";
import ScrollPositionContext from "contexts/scrollPosition";
import debounce from "lodash/debounce";
import React, { Component } from "react";
import { CustomScroll } from "react-custom-scroll";
import Pagination from "./pagination";

export default class List extends Component {
    static contextType = ScrollPositionContext;

    constructor(props) {
        super(props);
        this.scrollHandler = debounce(this.scrollHandler, 300);
    }

    scrollHandler = (e) => {
        this.context?.setPosition?.(e.target.scrollTop);
    };

    componentDidMount() {
        this.context?.setInitialLoad?.(true);
        this.getList(this.props);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.shouldUpdate && !nextProps.isLoadingList) {
            this.context?.setInitialLoad?.(true);
            this.getList(nextProps);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.context?.initialLoad && prevProps.itemsLoadedAt !== this.props.itemsLoadedAt) {
            this.context?.setInitialLoad?.(false);
            this.scrollContainer?.updateScrollPosition(this.context.position);
            this.prevItemTimeout = setTimeout(() => {
                this.context?.setPrevItemId?.(undefined);
            }, 3000);
        }
    }

    componentWillUnmount() {
        clearTimeout(this.prevItemTimeout);
        this.context?.setPrevItemId?.(undefined);
    }

    getList = ({ getList, params }) => {
        getList(params);
    };

    changePage = (start) => {
        const { mergeParams } = this.props;
        mergeParams({ start });
    };

    changePageSize = (pageSize) => {
        const { mergeParams, params } = this.props;
        const newPage = Math.floor(params.start / pageSize);
        const start = newPage * pageSize;
        mergeParams({ start, length: pageSize });
    };

    renderItems = () => {
        const { renderRow, items, isTable, isLoadingList } = this.props;
        if (isLoadingList) {
            return <Loader prefix="absolute-center" />;
        }
        const emptyListRow = () => {
            return isTable ? (
                <tr>
                    <td colSpan={3}>
                        <span className="list__body-empty">Не найдено</span>
                    </td>
                </tr>
            ) : (
                <span className="list__body-empty">Не найдено</span>
            );
        };
        return items && items.length ? items.map(renderRow) : emptyListRow();
    };

    renderPagination = () => {
        const { count, params, isLoadingCount, withoutPageSize } = this.props;
        return params.length > 0 ? (
            <Pagination
                withoutPageSize={withoutPageSize}
                count={count}
                isNotExportable={true}
                pageSizeOptions={[30, 50, 100, 200]}
                isLoadingCount={isLoadingCount}
                length={params.length}
                start={params.start}
                pageSize={this.props.params.length}
                onPageSizeChange={this.changePageSize}
                action={this.changePage}
            />
        ) : null;
    };

    renderTable = () => {
        const { renderHead, isLoadingList, items, EmptyList } = this.props;
        if (isLoadingList) {
            return <Loader prefix="absolute-center" />;
        }
        if (items?.length === 0 && EmptyList) {
            return <EmptyList />;
        }
        return (
            <table className="table table-sm table-hover table-clickable border-bottom">
                {renderHead()}
                <tbody>{this.renderItems()}</tbody>
            </table>
        );
    };

    render() {
        const { isTable } = this.props;
        return (
            <>
                <div className="list__body-wrap">
                    <div className="list__body content-wrapper">
                        <CustomScroll
                            heightRelativeToParent="100%"
                            ref={(el) => (this.scrollContainer = el)}
                            onScroll={this.scrollHandler}
                        >
                            <div className="container-fluid">{isTable ? this.renderTable() : this.renderItems()}</div>
                        </CustomScroll>
                    </div>
                </div>
                {this.renderPagination()}
            </>
        );
    }
}
